<template>
  <section class="banner__area pt-60 pb-25 ad-banner-section ad-banner-section--interactive">
    <div class="container">
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[6]">
          <div class="ad-banner-3d">
            <AdBannerMouse3d>
              <div class="ad-banner-3d__inner">
                <div
                  class="banner__item p-relative w-img mb-30 ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                  :key="adKey(adsByType[6], 6)"
                >
                  <div class="banner__img ad-banner__media">
                    <a
                      v-if="linkIsExt(adsByType[6])"
                      :href="linkExtHref(adsByType[6])"
                      class="d-block h-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="ad-banner__img"
                        :src="adsByType[6].image_url"
                        :alt="adPlainTitle(adsByType[6].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                    <router-link v-else :to="linkPath(adsByType[6])" class="d-block h-100">
                      <img
                        class="ad-banner__img"
                        :src="adsByType[6].image_url"
                        :alt="adPlainTitle(adsByType[6].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </router-link>
                  </div>
                  <div class="banner__content banner__content-sd text-center ad-banner__content--hero">
                    <div class="banner-button mb-20">
                      <a
                        v-if="linkIsExt(adsByType[6])"
                        :href="linkExtHref(adsByType[6])"
                        class="st-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{ adsByType[6].tag }}</a>
                      <router-link v-else :to="linkPath(adsByType[6])" class="st-btn">{{ adsByType[6].tag }}</router-link>
                    </div>
                    <h6>
                      <a
                        v-if="linkIsExt(adsByType[6])"
                        :href="linkExtHref(adsByType[6])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span class="ad-banner-3d__title" v-html="adsByType[6].title"></span>
                        <span v-if="adsByType[6].text" class="ad-banner-3d__sub">{{ adsByType[6].text }}</span>
                      </a>
                      <router-link v-else :to="linkPath(adsByType[6])">
                        <span class="ad-banner-3d__title" v-html="adsByType[6].title"></span>
                        <span v-if="adsByType[6].text" class="ad-banner-3d__sub">{{ adsByType[6].text }}</span>
                      </router-link>
                    </h6>
                  </div>
                </div>
              </div>
            </AdBannerMouse3d>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[7]">
          <div class="row">
            <div class="col-md-12">
              <div class="ad-banner-3d">
                <AdBannerMouse3d>
                  <div class="ad-banner-3d__inner">
                    <div
                      class="banner__item p-relative mb-30 w-img ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                      :key="adKey(adsByType[7], 7)"
                    >
                      <div class="banner__img ad-banner__media">
                        <a
                          v-if="linkIsExt(adsByType[7])"
                          :href="linkExtHref(adsByType[7])"
                          class="d-block h-100"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            class="ad-banner__img"
                            :src="adsByType[7].image_url"
                            :alt="adPlainTitle(adsByType[7].title)"
                            loading="lazy"
                            decoding="async"
                          />
                        </a>
                        <router-link v-else :to="linkPath(adsByType[7])" class="d-block h-100">
                          <img
                            class="ad-banner__img"
                            :src="adsByType[7].image_url"
                            :alt="adPlainTitle(adsByType[7].title)"
                            loading="lazy"
                            decoding="async"
                          />
                        </router-link>
                      </div>
                      <div class="banner__content banner__content-sd text-center ad-banner__content--hero">
                        <h6>
                          <a
                            v-if="linkIsExt(adsByType[7])"
                            :href="linkExtHref(adsByType[7])"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span class="ad-banner-3d__title" v-html="adsByType[7].title"></span>
                          </a>
                          <router-link v-else :to="linkPath(adsByType[7])">
                            <span class="ad-banner-3d__title" v-html="adsByType[7].title"></span>
                          </router-link>
                        </h6>
                        <p v-if="adsByType[7].text">{{ adsByType[7].text }}</p>
                        <div class="banner-button mt-20 d-none d-sm-block">
                          <a
                            v-if="linkIsExt(adsByType[7])"
                            :href="linkExtHref(adsByType[7])"
                            class="st-btn-3 b-radius"
                            target="_blank"
                            rel="noopener noreferrer"
                          >{{ adsByType[7].tag }}</a>
                          <router-link v-else :to="linkPath(adsByType[7])" class="st-btn-3 b-radius">{{ adsByType[7].tag }}</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </AdBannerMouse3d>
              </div>
            </div>

            <div class="col-md-12" v-if="adsByType[8]">
              <div class="ad-banner-3d">
                <AdBannerMouse3d>
                  <div class="ad-banner-3d__inner">
                    <div
                      class="banner__item p-relative w-img mb-30 ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                      :key="adKey(adsByType[8], 8)"
                    >
                      <div class="banner__img ad-banner__media">
                        <a
                          v-if="linkIsExt(adsByType[8])"
                          :href="linkExtHref(adsByType[8])"
                          class="d-block h-100"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            class="ad-banner__img"
                            :src="adsByType[8].image_url"
                            :alt="adPlainTitle(adsByType[8].title)"
                            loading="lazy"
                            decoding="async"
                          />
                        </a>
                        <router-link v-else :to="linkPath(adsByType[8])" class="d-block h-100">
                          <img
                            class="ad-banner__img"
                            :src="adsByType[8].image_url"
                            :alt="adPlainTitle(adsByType[8].title)"
                            loading="lazy"
                            decoding="async"
                          />
                        </router-link>
                      </div>
                      <div class="banner__content ad-banner__content--hero">
                        <h6>
                          <a
                            v-if="linkIsExt(adsByType[8])"
                            :href="linkExtHref(adsByType[8])"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span class="ad-banner-3d__title" v-html="adsByType[8].title"></span>
                          </a>
                          <router-link v-else :to="linkPath(adsByType[8])">
                            <span class="ad-banner-3d__title" v-html="adsByType[8].title"></span>
                          </router-link>
                        </h6>
                        <p v-if="adsByType[8].text">{{ adsByType[8].text }}</p>
                      </div>
                    </div>
                  </div>
                </AdBannerMouse3d>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-12" v-if="adsByType[9]">
          <div class="ad-banner-3d">
            <AdBannerMouse3d>
              <div class="ad-banner-3d__inner">
                <div
                  class="banner__item p-relative mb-30 w-img ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                  :key="adKey(adsByType[9], 9)"
                >
                  <div class="banner__img ad-banner__media">
                    <a
                      v-if="linkIsExt(adsByType[9])"
                      :href="linkExtHref(adsByType[9])"
                      class="d-block h-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="ad-banner__img"
                        :src="adsByType[9].image_url"
                        :alt="adPlainTitle(adsByType[9].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                    <router-link v-else :to="linkPath(adsByType[9])" class="d-block h-100">
                      <img
                        class="ad-banner__img"
                        :src="adsByType[9].image_url"
                        :alt="adPlainTitle(adsByType[9].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </router-link>
                  </div>
                  <div class="banner__content banner__content-sd text-center ad-banner__content--hero">
                    <div class="banner-button mb-20">
                      <a
                        v-if="linkIsExt(adsByType[9])"
                        :href="linkExtHref(adsByType[9])"
                        class="st-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{ adsByType[9].tag }}</a>
                      <router-link v-else :to="linkPath(adsByType[9])" class="st-btn">{{ adsByType[9].tag }}</router-link>
                    </div>
                    <h6>
                      <a
                        v-if="linkIsExt(adsByType[9])"
                        :href="linkExtHref(adsByType[9])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span class="ad-banner-3d__title" v-html="adsByType[9].title"></span>
                        <span v-if="adsByType[9].text" class="ad-banner-3d__sub">{{ adsByType[9].text }}</span>
                      </a>
                      <router-link v-else :to="linkPath(adsByType[9])">
                        <span class="ad-banner-3d__title" v-html="adsByType[9].title"></span>
                        <span v-if="adsByType[9].text" class="ad-banner-3d__sub">{{ adsByType[9].text }}</span>
                      </router-link>
                    </h6>
                  </div>
                </div>
              </div>
            </AdBannerMouse3d>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AdBannerMouse3d from './AdBannerMouse3d.vue';
import {
  adIsExternal as linkIsExt,
  adRouterPath as linkPath,
  adExternalHref as linkExtHref,
} from '@/utils/ad-media';

export default {
  components: { AdBannerMouse3d },
  props: {
    ads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndexByType: {},
      rotationMs: 3000,
      rotationIntervalId: null,
    }
  },
  watch: {
    ads: {
      immediate: true,
      deep: true,
      handler() {
        this.syncActiveIndexes()
        this.restartRotation()
      },
    },
  },
  computed: {
    bannerTypes() {
      return [6, 7, 8, 9]
    },
    adsByType() {
      const groupedAds = {}

      this.ads.forEach((ad) => {
        const t = Number(ad.add_type)
        if (this.bannerTypes.includes(t)) {
          if (!groupedAds[t]) groupedAds[t] = []
          groupedAds[t].push(ad)
        }
      })

      const result = {}
      this.bannerTypes.forEach((t) => {
        const list = groupedAds[t] || []
        if (!list.length) return
        const i = Number.isFinite(this.activeIndexByType[t])
          ? this.activeIndexByType[t]
          : 0
        result[t] = list[i] || list[0]
      })

      return result
    },
  },
  mounted() {
    this.syncActiveIndexes()
    this.restartRotation()
  },
  beforeUnmount() {
    if (this.rotationIntervalId) clearInterval(this.rotationIntervalId)
  },
  methods: {
    linkIsExt,
    linkPath,
    linkExtHref,
    syncActiveIndexes() {
      this.bannerTypes.forEach((t) => {
        const list = this.ads.filter((ad) => Number(ad.add_type) === t)
        if (!list.length) {
          delete this.activeIndexByType[t]
          return
        }
        const current = Number(this.activeIndexByType[t] || 0)
        this.activeIndexByType[t] = current >= list.length ? 0 : current
      })
    },
    restartRotation() {
      if (this.rotationIntervalId) clearInterval(this.rotationIntervalId)
      const hasMultipleAds = this.bannerTypes.some(
        (t) => this.ads.filter((ad) => Number(ad.add_type) === t).length > 1
      )
      if (!hasMultipleAds) {
        this.rotationIntervalId = null
        return
      }
      this.rotationIntervalId = setInterval(() => {
        this.bannerTypes.forEach((t) => {
          const list = this.ads.filter((ad) => Number(ad.add_type) === t)
          if (list.length > 1) {
            const i = Number(this.activeIndexByType[t] || 0)
            this.activeIndexByType[t] = (i + 1) % list.length
          }
        })
      }, this.rotationMs)
    },
    adKey(ad, type) {
      const id = ad?.id ?? ad?.ad_id ?? ad?.advertisement_id ?? ad?.image_url ?? 'ad';
      const idx = Number(this.activeIndexByType[type] || 0);
      return `${type}-${idx}-${id}`;
    },
    adPlainTitle(html) {
      if (!html || typeof html !== 'string') return '';
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
  },
};
</script>

<style scoped>
/* 3D: _ad-banner-3d.scss */
.ad-rotate-swap {
  animation: ad-rotate-swap 0.55s ease both;
}

@keyframes ad-rotate-swap {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>